import type { Pagination, PourType } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/pour-types';

export function getPourTypes(query?: PourType.SearchQuery) {
    return api.get<Pagination<PourType>>(rootPath, query);
}

export function getPourType(id: number) {
    return api.get<PourType.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postPourType(data: PourType.CreateRequest) {
    return api.post<PourType>(rootPath, data);
}

export function putPourType(id: number, data: PourType.UpdateRequest) {
    return api.put<PourType>(`${rootPath}/${id}`, data);
}

export function deletePourType({ id }: PourType.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
